module.exports = __webpack_public_path__ + "img/edit_purple.0bd529b9.svg";